<template>
  <div class="text-center">
    <div class="row no-gutters">
      <div class="col">
        <h3 class="text-left ml-4">Vessel Objective Evidence List</h3>
      </div>
      <div class="col-md-auto">
        <label class="col-form-label pr-2 font-weight-bold">Filter By Year: </label>
      </div>
      <div class="col-md-auto px-1">
        <select name="month" id="month" class="form-control form-control-sm" v-model="oeYear" :disabled="loading">
          <option :value="year" v-for="year in years">{{year}}</option>
        </select>
      </div>
      <div class="col-3">
        <input type="text" v-model="filters.search" name="vesselSearch" class="form-control form-control-sm" placeholder="Search Objective Evidence" :disabled="loading" @keyup.enter="setOeToTable()">
      </div>
    </div>
    <div class="row no-gutters pb-2 align-items-center"> <!-- Added align-items-center for proper vertical alignment -->
      <nav aria-label="...">
        <ul class="pagination text-smallest mb-0 pb-0">
          <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1 || loading}">
            <button class="page-link" @click="setPage(1)" :disabled="loading">First</button>
          </li>

          <li v-for="page in paginationPages" :key="page" class="page-item"
              :class="{ 'disabled': page === '...' || loading, 'active': page === pagination.currentPage }">
            <button class="page-link" @click="setPage(page)" :disabled="loading">{{ page }}</button>
          </li>

          <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage || loading}">
            <button class="page-link" @click="setPage(pagination.lastPage)" :disabled="loading">Last</button>
          </li>
        </ul>
      </nav>

      <!-- Changed 'float-right' to 'ml-auto' -->
      <div class="ml-auto">
        <div class="dropdown dropright pr-1" v-if="true">
          <button id="committeeReport"
                  aria-expanded="false"
                  aria-haspopup="true"
                  :disabled="loading"
                  :class="['e-btn e-btn-primary force-white-all', {'e-btn-blue-gray-disabled': loading}]"
                  data-toggle="dropdown">
            <font-awesome-icon class="mr-1" icon="download"/>
            Download All
          </button>
          <div aria-labelledby="committeeReport" class="dropdown-menu">
            <button class="dropdown-item text-secondary font-weight-bolder" @click="downloadObjectiveEvidenceCategory('excel', null)" type="button">
              <font-awesome-icon icon="file-excel"/>
              Excel
            </button>
            <button class="dropdown-item text-secondary font-weight-bolder" @click="downloadObjectiveEvidenceCategory('pdf', null)" type="button">
              <font-awesome-icon icon="file-pdf"/>
              PDF
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row no-gutters" style="height: 80vh; overflow-y: auto">
      <div class="col-sm-12">
        <table class="small e-tbl">
          <thead class="bg-white" style="position: sticky; top: 0; z-index: 2">
          <tr>
            <th style="width: 10%" class="align-middle no-select cursor-pointer" scope="col" @click="sorterArrowSetDirection('category')">
              CATEGORY
              <span style="cursor: pointer" class="h6 ml-2" @click="sorting('name')">
                <font-awesome-icon icon="arrow-up" v-if="filters.sort_order === 'asc' && filters.sort_by === 'name'" class="sort-arrow-up"/>
                <font-awesome-icon icon="arrow-down" v-else-if="filters.sort_order === 'desc' && filters.sort_by === 'name'" class="sort-arrow-down"/>
                <font-awesome-icon icon="sort" v-else/>
              </span>
            </th>
            <th class="align-middle no-select cursor-pointer" scope="col">
              OBJECTIVE EVIDENCE
              <font-awesome-icon
                icon="question-circle"
                data-toggle="modal"
                style="cursor:pointer"
                data-target="#objectiveEvidenceLegendModal">
              </font-awesome-icon>
            </th>
            <th style="width: 10%" class="align-middle no-select cursor-pointer">
              COUNT
              <span style="cursor: pointer" class="h6 ml-2" @click="sorting('count')">
                <font-awesome-icon icon="arrow-up" v-if="filters.sort_order === 'asc' && filters.sort_by === 'count'" class="sort-arrow-up"/>
                <font-awesome-icon icon="arrow-down" v-else-if="filters.sort_order === 'desc' && filters.sort_by === 'count'" class="sort-arrow-down"/>
                <font-awesome-icon icon="sort" v-else/>
              </span>
            </th>
          </tr>
          </thead>
          <tbody>
            <!-- Loading State -->
            <tr v-if="loading">
              <td colspan="100%">
                <app-loading></app-loading>
              </td>
            </tr>

            <template v-else>
              <!-- No Results State -->
              <tr v-if="objectiveEvidencesByCategory.length === 0">
                <td colspan="100%" class="align-middle text-center font-weight-bold bg-secondary text-white py-3">
                  NO RESULTS FOUND
                </td>
              </tr>

              <!-- Main Data Loop -->
              <template v-else v-for="(data, oeIndex) in objectiveEvidencesByCategory">

                <!-- MAIN ROW -->
                <tr :key="'main-' + oeIndex"
                    @dblclick="showObjectiveEvidenceCategoryModal(data, oeIndex)"
                    class="oe-list cursor-pointer no-select transition-all"
                    :class="{ 'bg-light font-weight-bold': expandedRow === oeIndex }">

                  <!-- Category Column -->
                  <td class="align-middle fw-bold">
                    <i class="fas mr-2"
                       :class="expandedRow === oeIndex ? 'fa-chevron-down text-primary' : 'fa-chevron-right text-muted'"
                       ></i>
                    {{ data.category }}
                  </td>

                  <!-- Objective Evidence Column -->
                  <td class="align-middle">
<!--                    <div class="d-flex align-items-center justify-content-between w-100 pr-1 pl-1">-->
                      <!-- Left side: Badges -->
<!--                      <div class="d-flex align-items-center flex-wrap gap-1">-->
                        <template v-if="data.objective_evidences.length > 0">
                          <strong v-for="x in data.objective_evidences"> x</strong>
                        </template>
<!--                        <span v-for="(oe, idx) in data.objective_evidences"-->
<!--                              :key="idx"-->
<!--                              class="badge badge-primary me-1 mb-1">-->
<!--                          X-->
<!--                        </span>-->
<!--                      </div>-->

                      <!-- Right side: Button -->
<!--                      <button-->
<!--                        type="button"-->
<!--                        class="e-btn-sm e-btn e-btn-blue d-inline-flex align-items-center gap-1"-->
<!--                        @click.stop="toggleExpand(oeIndex)">-->
<!--                        <i class="fas" :class="expandedRow === oeIndex ? 'fa-chevron-up' : 'fa-chevron-down'"></i>-->
<!--                        <span class="e-text-white">{{ expandedRow === oeIndex ? 'Hide Details' : 'View Details' }}</span>-->
<!--                      </button>-->
<!--                    </div>-->
                  </td>

                  <!-- Count Column -->
                  <td class="align-middle text-center">
                    <span class="badge badge-secondary badge-pill px-3 py-2">
                      {{ data.objective_evidences.length }}
                    </span>
                  </td>
                </tr>
                <tr v-if="expandedRow === oeIndex"
                    :key="'detail-' + oeIndex"
                    class="bg-light border-bottom">
                  <td colspan="100%" class="p-3">

                    <div class="card shadow-sm border-0">
                      <div class="card-header bg-white d-flex justify-content-between align-items-center py-2">
                        <!-- Title section -->
                        <h6 class="m-0 font-weight-bold">
                          <i class="fas fa-list-alt mr-2"></i> Objective Evidence Titles for {{ data.category }}
                        </h6>

                        <!-- Action buttons grouped on the right -->
                        <div class="d-flex align-items-center gap-2">
                          <!-- Download Dropdown -->
                          <div class="dropdown dropright pr-1" v-if="true">
                            <button id="committeeReport"
                                    aria-expanded="false"
                                    aria-haspopup="true"
                                    :disabled="loading"
                                    :class="['e-btn e-btn-primary force-white-all', {'e-btn-blue-gray-disabled': loading}]"
                                    data-toggle="dropdown">
                              <font-awesome-icon class="mr-1" icon="download"/>
                              Download
                            </button>
                            <div aria-labelledby="committeeReport" class="dropdown-menu">
                              <button class="dropdown-item text-secondary font-weight-bolder" @click="downloadObjectiveEvidenceCategory('excel', data.category_id)" type="button">
                                <font-awesome-icon icon="file-excel"/>
                                Excel
                              </button>
                              <button class="dropdown-item text-secondary font-weight-bolder" @click="downloadObjectiveEvidenceCategory('pdf', data.category_id)" type="button">
                                <font-awesome-icon icon="file-pdf"/>
                                PDF
                              </button>
                            </div>
                          </div>

                          <!-- Close Button -->
                          <button class="e-btn e-btn-sm e-btn-red py-1 px-2" @click.stop="toggleExpand(oeIndex)">
                            <i class="fas fa-times mr-1"></i> Close
                          </button>
                        </div>
                      </div>

                      <div class="card-body" style="max-height: 250px; overflow-y: auto;">
                        <ul class="mb-0 pl-3 text-secondary oe-description-list" style="line-height: 1.4">
                          <li v-for="(oe, itemIdx) in data.objective_evidences"
                              :key="itemIdx"
                              class="mb-2 p-0 text-left"
                              v-html="oe.description || 'No description available'">
                          </li>
                        </ul>
                      </div>
                    </div>

                  </td>
                </tr>
              </template>
            </template>
          </tbody>
        </table>
        <view-objective-evidences
          v-if="OECategoryIndex !== null"
          :objective-evidences-by-category="objectiveEvidencesByCategory[OECategoryIndex]"
          @close="OECategoryIndex = null"
        />
      </div>
    </div>
    <div class="modal fade" id="objectiveEvidenceModal" tabindex="-1" aria-labelledby="objectiveEvidenceLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header align-items-center">
            <h5 class="modal-title mr-auto" id="objectiveEvidenceLabel">
              Objective Evidence Titles for <span class="text-danger h5 ">{{ objectiveEvidenceListModal.category }}</span>
            </h5>

            <!-- Extra Action Button -->
            <button type="button" class="e-btn e-btn-primary mr-3" @click="setOeSelectedIndex(objectiveEvidenceListModal.index)">
              Show Attachments
            </button>

            <div class="dropdown dropright mr-3">
              <button id="committeeReport"
                      aria-expanded="false"
                      aria-haspopup="true"
                      :disabled="loading"
                      :class="['e-btn e-btn-primary force-white-all', {'e-btn-blue-gray-disabled': loading}]"
                      data-toggle="dropdown">
                <font-awesome-icon class="mr-1" icon="download"/>
                Download
              </button>
              <div aria-labelledby="committeeReport" class="dropdown-menu">
                <button class="dropdown-item text-secondary font-weight-bolder" @click="downloadObjectiveEvidenceCategory('excel', objectiveEvidenceListModal.category_id, objectiveEvidenceListModal.category)" type="button">
                  <font-awesome-icon icon="file-excel"/>
                  Excel
                </button>
                <button class="dropdown-item text-secondary font-weight-bolder" @click="downloadObjectiveEvidenceCategory('pdf', objectiveEvidenceListModal.category_id, objectiveEvidenceListModal.category)" type="button">
                  <font-awesome-icon icon="file-pdf"/>
                  PDF
                </button>
                <button class="dropdown-item text-secondary font-weight-bolder" @click="downloadObjectiveEvidenceCategory('excelAttachment', objectiveEvidenceListModal.category_id, objectiveEvidenceListModal.category)" type="button">
                  <font-awesome-icon icon="file-pdf"/>
                  Excel w/ Attachments
                </button>
                <button class="dropdown-item text-secondary font-weight-bolder" @click="downloadObjectiveEvidenceCategory('pdfAttachment', objectiveEvidenceListModal.category_id, objectiveEvidenceListModal.category)" type="button">
                  <font-awesome-icon icon="file-pdf"/>
                  PDF w/ Attachments
                </button>
              </div>
            </div>

            <!-- Close Button using FontAwesome -->
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" style="outline: none; margin: 0; padding: 0;">
              <font-awesome-icon icon="times" style="font-size: 20pt;" />
            </button>
          </div>
          <div class="modal-body">
            <div ref="scrollContainer" class="card-body" style="max-height: 250px; overflow-y: auto;">
              <ul class="mb-0 pl-3 text-secondary oe-description-list" style="line-height: 1.4">
                <li v-for="(oe, itemIdx) in objectiveEvidenceListModal?.objective_evidences"
                    :key="itemIdx"
                    class="mb-2 p-0 text-left"
                    v-html="oe.description || 'No description available'">
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="objectiveEvidenceLegendModal" tabindex="-1" aria-labelledby="objectiveEvidenceLegendModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header align-items-center justify-content-between position-relative">
            <!-- Centered Title -->
            <div class="w-100 text-left pr-5">
              <h5 class="modal-title font-weight-bold d-inline-block" style="font-size: 0.9rem;" id="objectiveEvidenceLegendModalLabel">
                Conditions for Objective Evidence Display
              </h5>
            </div>

            <!-- Right Group: Badge + Close Button -->
            <div class="position-absolute d-flex align-items-center" style="right: 1rem; top: 50%; transform: translateY(-50%);">
              <span class="badge badge-success px-2 py-1 mr-2">
                <i class="fas fa-filter mr-1"></i> Strict Inclusion Applied
              </span>
              <button type="button" class="close m-0 p-0" data-dismiss="modal" aria-label="Close" style="outline: none; margin: 0; padding: 0;">
                <span aria-hidden="true" style="font-size: 20pt;">&times;</span>
              </button>
            </div>
          </div>
          <div class="modal-body">
            <div class="row">
              <!-- Requirement 1 -->
              <div class="col-md-3 col-sm-6 mb-2 mb-md-0">
                <div class="d-flex align-items-start">
                  <div class="badge badge-light-success text-success p-2 mr-2 rounded">
                    <i class="fas fa-image fa-lg" />
                  </div>
                  <div>
                    <div class="font-weight-bold text-dark small">Before</div>
                    <div class="text-muted extra-small">Has attached "Before" photo</div>
                  </div>
                </div>
              </div>

              <!-- Requirement 2 -->
              <div class="col-md-3 col-sm-6 mb-2 mb-md-0">
                <div class="d-flex align-items-start">
                  <div class="badge badge-light-success text-success p-2 mr-2 rounded">
                    <i class="fas fa-check-circle fa-lg" />
                  </div>
                  <div>
                    <div class="font-weight-bold text-dark small">After</div>
                    <div class="text-muted extra-small">Has attached "After" photo</div>
                  </div>
                </div>
              </div>

              <!-- Requirement 3 -->
              <div class="col-md-3 col-sm-6 mb-2 mb-md-0">
                <div class="d-flex align-items-start">
                  <div class="badge badge-light-info text-info p-2 mr-2 rounded">
                    <i class="fas fa-calendar-check fa-lg" />
                  </div>
                  <div>
                    <div class="font-weight-bold text-dark small">Rectified Date</div>
                    <div class="text-muted extra-small">Must Have Rectified Date</div>
                  </div>
                </div>
              </div>

              <!-- Requirement 4 -->
              <div class="col-md-3 col-sm-6">
                <div class="d-flex align-items-start">
                  <div class="badge badge-light-dark text-dark p-2 mr-2 rounded">
                    <i class="fas fa-lock fa-lg" />
                  </div>
                  <div>
                    <div class="font-weight-bold text-dark small">Report Status</div>
                    <div class="text-muted extra-small">Report is fully <strong>Closed</strong></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {vueAppMixin} from "@/mixins/vueAppMixin";
import AppLoading from "@/components/elements/AppLoading";

import {permissionMixin} from "@/mixins/permissionMixins";
import {PaginationMixin} from "@/mixins/PaginationMixin";
import ImageSlider from "@/components/common/ImageSlider.vue";
import ImageSliderMixin from "@/mixins/ImageSliderMixin";
import SorterArrow from "@/components/common/SorterArrow.vue";
import SorterArrowMixin from "@/mixins/SorterArrowMixin";
import _ from 'lodash';
import {mapActions, mapGetters} from "vuex";
import ViewObjectiveEvidences from "@/components/modules/ia/vessel/ViewObjectiveEvidences.vue";
import OETitleViewer from "@/components/modules/ia/OETitleViewer.vue";

export default {
  mixins: [vueAppMixin,permissionMixin,PaginationMixin, ImageSliderMixin, SorterArrowMixin],
  components: {AppLoading, ImageSlider, SorterArrow, ViewObjectiveEvidences, OETitleViewer},

  name: 'ObjectiveEvidenceList',
  data() {
    return {
      loading: false,
      selectedImageIndex: 0,
      objectiveEvidencesByCategory : [],
      objectiveEvidenceIndex : null,
      changeValueForRendering : false,
      showSlider : false,
      imagesToSlide: {
        before : [],
        after  : []
      },
      OECategoryIndex : null,
      years:Array.from({length:100},(_,i)=>new Date().getFullYear() - i),
      oeYear : new Date().getFullYear(),
      filters: {
        search: '',
        sort_by: 'count',
        sort_order: 'desc'
      },
      expandedRow: null,
      objectiveEvidenceListModal:{
        index: 0,
        category: '',
        category_id: '',
        objective_evidences: [],
      },
    }
  },
  methods: {
    ...mapActions([
      'downloadObjectiveEvidenceReport',
      'getLatestObjectiveEvidences'
    ]),
    setOeSelectedIndex(index) {
      this.OECategoryIndex = index;
    },
    sorterArrowSetDirection(orderBy) {
      this.currentOrderBy = orderBy;
      this.$emit('sorterArrowSetDirection', orderBy);
    },
    runCallBack(param) {
      if (param.direction === '') {
        this.currentOrderBy = '';
      }
      this.objectiveEvidencesByCategory = _.orderBy(this.objectiveEvidencesByCategory, [param.orderBy], [param.direction]);
    },
    toggleExpand(index) {
      if (this.expandedRow === index) {
        this.expandedRow = null;
      } else {
        this.expandedRow = index;
      }
    },
    async sorting(sort_by){
      this.filters.sort_by = sort_by
      this.filters.sort_order = this.filters.sort_order === 'desc'? 'asc':'desc'
      await this.setOeToTable(1)
    },
    async setPage(page = null) {
      this.pagination.currentPage = page ?? 1;
      await this.setOeToTable(page)
    },
    async downloadObjectiveEvidenceCategory(fileType, category_id, category) {
      const params = {
        filter: {
          year: this.oeYear
        },
        search: this.filters.search,
        sort_by: this.filters.sort_by,
        sort_order: this.filters.sort_order,
        fileType,
        paginate: 0,
      }

      if(category_id !== null){
        params.category_id = category_id
      }

      const fileTypeLabel =
        fileType === 'pdf' ? 'PDF' :
          fileType === 'excel' ? 'EXCEL' :
            fileType === 'excelAttachment' ? 'EXCEL WITH ATTACHMENT' :
              fileType === 'pdfAttachment' ? 'PDF WITH ATTACHMENT' : 'REPORT';

      swal.fire({
        'title': `GENERATING OBJECTIVE EVIDENCE ${category_id === null? 'ALL':''} CATEGORY ${fileTypeLabel} REPORT <br>Please wait.....`,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      })

      swal.showLoading()
      const response = await this.downloadObjectiveEvidenceReport(params)
      swal.close();

      // let mime_type = fileType === 'pdf' ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      let mime_type = 'application/pdf';
      let fileExtension = 'pdf';

      if (fileType === 'excel') {
        mime_type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        fileExtension = 'xlsx';
      } else if (fileType === 'excelAttachment' || fileType === 'pdfAttachment') {
        mime_type = 'application/zip';
        fileExtension = 'zip';
      }

      // 3. Create blob URL
      const url = window.URL.createObjectURL(new Blob([response], { type: mime_type }));

      // 4. Build filename with proper extension
      const filename = `OBJECTIVE_EVIDENCE${category_id === null ? '_ALL' : ''}_CATEGORY_${category}_${this.oeYear}.${fileExtension}`;

      // 5. Trigger download
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();

      // 6. Cleanup DOM and Object URL memory
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    showObjectiveEvidenceCategoryModal(data, index){
      this.objectiveEvidenceListModal.index = index
      this.objectiveEvidenceListModal.category = data.category
      this.objectiveEvidenceListModal.category_id = data.category_id
      this.objectiveEvidenceListModal.objective_evidences = data.objective_evidences

      $('#objectiveEvidenceModal').modal('show')

      setTimeout(() => {
        const modalElem = document.getElementById('objectiveEvidenceModal'); // replace with your modal ID
        if (modalElem) {
          // Reset modal container
          modalElem.scrollTop = 0;

          // Reset all scrollable elements inside the modal
          const scrollables = modalElem.querySelectorAll('.modal-body, .card-body');
          scrollables.forEach(el => el.scrollTop = 0);
        }
      }, 150);
    },
    async setOeToTable(page = 1) {
      this.loading = true;
      const params = {
        year: this.oeYear,
        search: this.filters.search,
        page,
        sort_by: this.filters.sort_by,
        sort_order: this.filters.sort_order
      }
      await this.getLatestObjectiveEvidences(params);
      this.objectiveEvidencesByCategory = this.latestOeLists;
      this.loading = false;
    }
  },
  computed : {
    ...mapGetters([
      'latestOeLists'
    ]),
  },
  async created() {
    this.setOEList = _.debounce(this.setOeToTable, 10);
    await this.setOeToTable();

  },
  watch: {
    'oeYear'() {
      this.setOEList()
    },
  },
}
</script>

<style scoped lang="scss">
.oe-list:hover {
  background-color: #dae8f4;
}
.oe-description-list {
  :deep(li ol),
  :deep(li ul) {
    padding-left: 1.5rem !important;
    margin-top: 0.25rem !important;
    margin-bottom: 0.5rem !important;
  }

  :deep(li ol li),
  :deep(li ul li) {
    list-style-position: outside !important;
    margin-bottom: 0.25rem !important;
  }

  :deep(p) {
    margin-bottom: 0.25rem !important;
  }
}
</style>
